import { MessageSquare } from 'lucide-react'
import { useTranslation } from '@/hooks/use-translation'

type BrandVoice = {
  name: string
  voiceTone: string
  targetAudience: string | null
  communicationStyle: string | null
}

type BrandVoicesResult = {
  brandVoices: BrandVoice[]
  count: number
}

type Props = {
  result: BrandVoicesResult | null | undefined
}

export function BrandVoicesCard({ result }: Props) {
  const t = useTranslation()

  if (!result || !result.brandVoices) return null

  if (result.count === 0) {
    return (
      <div className="bg-card border border-border rounded-xl p-3 my-1.5 text-muted-foreground text-sm">
        {t('agent.tools.brandVoices.empty')}
      </div>
    )
  }

  return (
    <div className="bg-card border border-border rounded-xl p-3 my-1.5">
      <div className="flex items-center gap-2 mb-2">
        <MessageSquare className="w-4 h-4 text-primary" />
        <span className="text-sm font-medium text-card-foreground">
          {t('agent.tools.brandVoices.title', { count: result.count })}
        </span>
      </div>
      <ul className="space-y-1.5">
        {result.brandVoices.map((voice) => (
          <li key={voice.name} className="flex flex-col px-2 py-1.5 rounded-lg bg-muted/40">
            <span className="text-sm font-medium text-card-foreground">{voice.name}</span>
            <span className="text-xs text-muted-foreground">{voice.voiceTone}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
